// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"df1cf58c","787":"5825e90f"}[chunkId] + ".chunk.js";
};